import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 2),
  maxWidth: 1200,
  margin: '0 auto',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(5, 3),
  },
}));

export const PageHeader = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '& h1': {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    background: 'linear-gradient(45deg, #FFA000, #FF6D00)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  '& p': {
    fontSize: '1.125rem',
    color: theme.palette.text.secondary,
  },
}));

export const SectionContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(8),
}));

export const TableOfContents = styled(Box)(({ theme }) => ({
  overflow: 'auto',
  maxHeight: '70vh',
  padding: theme.spacing(2),
}));

export const TOCItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ theme, active }) => ({
  padding: theme.spacing(1, 2),
  marginBottom: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  cursor: 'pointer',
  fontSize: '0.875rem',
  fontWeight: active ? 600 : 400,
  backgroundColor: active ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
  color: active ? theme.palette.primary.main : theme.palette.text.primary,
  '&:hover': {
    backgroundColor: active ? 'rgba(25, 118, 210, 0.12)' : 'rgba(0, 0, 0, 0.04)',
  },
  transition: theme.transitions.create(['background-color', 'color'], {
    duration: 150,
  }),
}));

export const TermsSection = styled(Box)(() => ({
  scrollMarginTop: 100, // Ensures the section heading is properly visible when scrolled to
}));

export const ExpansionPanel = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const PrintButton = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(4),
  right: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    right: theme.spacing(2),
    bottom: theme.spacing(2),
  },
}))